import { useRuleDetailContextValue } from '../context/RuleDetailProvider'

type Jurisdiction = ReturnType<
  typeof useRuleDetailContextValue
>['state']['jurisdictions'][number]

export const formatJurisdictionLabel = (j: Jurisdiction) =>
  `${j.name} (${j.level}${j.stateCode ? `, ${j.stateCode.toUpperCase()}` : ''})`
